import { Pipe, PipeTransform, TemplateRef } from '@angular/core';

@Pipe({
    name: 'wdxToastHeaderIsTemplate',
    standalone: true,
    pure: true,
})
export class WdxToastHeaderIsTemplatePipe implements PipeTransform {
    transform(header: string | TemplateRef<HTMLElement>): boolean {
        return header instanceof TemplateRef;
    }
}

@Pipe({
    name: 'wdxToastHeaderText',
    standalone: true,
    pure: true,
})
export class WdxToastHeaderTextPipe implements PipeTransform {
    transform(header: string | TemplateRef<HTMLElement>): string {
        return typeof header === 'string' ? header : '';
    }
}
